export type PaginationParams = {
  page?: number;
  pageNumber?: number;
};

/**
 * UI pagination is 1-based.
 */
export const normalizeUiPageFromParams = (
  params: PaginationParams,
  fallback = 1,
): number => {
  const uiPage = params.page ?? params.pageNumber ?? fallback;
  return Math.max(uiPage, 1);
};

/**
 * Some backend endpoints return pagination page as 0-based.
 * This converts API page to UI page (1-based), with a fallback
 * derived from the requested UI page.
 */
export const mapZeroBasedApiPageToUiPage = (
  apiPage: number | undefined,
  requestedUiPage: number,
): number => {
  const fallbackApiPage = Math.max(requestedUiPage - 1, 0);
  const normalizedApiPage = apiPage ?? fallbackApiPage;
  return Math.max(normalizedApiPage + 1, 1);
};
